import { AuthService } from '@services/auth/auth.service';
import { ActivatedRoute } from '@angular/router';
import { CookieService } from '@services/cookie/cookie.service';
import { StorageService } from '@services/storage/storage.service';
import { UtilService } from '@services/util/util.service';
import { VariablesService } from '@services/variables/variables.service';
import { Component, inject } from '@angular/core';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent {

  private storageService = inject(StorageService);
  private cookieService = inject(CookieService);
  private utilService = inject(UtilService);
  private variablesService = inject(VariablesService);
  private actRoute = inject(ActivatedRoute);
  private authService = inject(AuthService);

  ngOnInit() {
    this.logoutUser();
  }

  logoutUser() {
    this.storageService.delete('user');
    this.storageService.delete('userdata');
    this.storageService.deleteFromSession('showBanner');
    this.storageService.deleteFromSession('firebasePhoneData');
    this.cookieService.deleteCookie('u_auth', '.ketto.org');
    this.utilService.isToken = false;
    this.utilService.isLoggedIn.next(false);
    this.variablesService.userData.next(null);
    this.afterLogoutRedirect();
  }

  afterLogoutRedirect() {
    const REDIRECT_URI = this.actRoute.snapshot.queryParams['redirect_uri'];
    if (REDIRECT_URI && this.authService.verifyURI(REDIRECT_URI)) {
      this.utilService.nativeNavigation(REDIRECT_URI);
    } else {
      this.utilService.navigate('/');
    }
  }

}
